import type { ReadyWorldId } from './world/worlds'

export type AudioPreferences = {music:boolean;gameMuted?:boolean}

// Every edition shares the original six New York game tracks.
export const originalGameTracks=['01-City-Swing.m4a','02-Golden-Promenade.m4a','03-Rooftop-Bossa.m4a','04-Neon-Avenue.m4a','05-Parkside-Waltz.m4a','06-Big-City-Bounce.m4a'] as const
export const cityMusic:Record<ReadyWorldId,readonly string[]>={
  'new-york':originalGameTracks,
  'las-vegas':originalGameTracks,
  'mexico-city':originalGameTracks,
  'paris':originalGameTracks,
  'munich':originalGameTracks,
  'moscow':originalGameTracks,
  'venice':originalGameTracks,
  'beijing':originalGameTracks,
  'seoul':originalGameTracks,
  'tokyo':originalGameTracks,
  'sao-paulo':originalGameTracks,
  'new-delhi':originalGameTracks,
  'jakarta':originalGameTracks,
  'hanoi':originalGameTracks,
  'klavius':originalGameTracks,
  'solara':originalGameTracks,
  'atlantis':originalGameTracks,
  'cairo':originalGameTracks,
  'istanbul':originalGameTracks,
  'barcelona':originalGameTracks,
}

export const musicForWorld=(worldId:ReadyWorldId)=>cityMusic[worldId]

// An explicit unmute also restores music disabled by the former music-only button.
export function toggledGameAudio(state:AudioPreferences): AudioPreferences {
  const gameMuted=!state.gameMuted
  return {gameMuted,music:gameMuted?state.music:true}
}

// Call inside user gestures as well as effects. Browsers may reject the initial
// page-load attempt; a later interaction retries without changing preferences.
export function resumeGameMusic(audio:HTMLAudioElement|null,preferences:AudioPreferences) {
  if(!audio||preferences.gameMuted||!preferences.music)return
  audio.muted=false
  audio.volume=.48
  if(audio.paused)void audio.play().catch((error:DOMException)=>{
    if(error.name!=='NotAllowedError'&&error.name!=='AbortError')console.warn('Game music could not start',error.message)
  })
}
